/* eslint-disable react-hooks/rules-of-hooks */
import { useTranslation } from 'react-i18next';
import { formatter } from '@repo/shared';
import { type ColumnDef } from '@tanstack/react-table';

import { type ExtractStructureLeaderboardItem } from '@/api/generated.schemas';
import { ColumnHeader } from '@/components/blocks/data-table/column-header';

export const columns: Array<ColumnDef<ExtractStructureLeaderboardItem>> = [
  {
    accessorKey: 'model',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('overview.model')}
        />
      );
    },
    cell: ({ row }) => row.original.model,
  },
  {
    accessorKey: 'amountOfModelRuns',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('overview.amountOfModelRuns')}
        />
      );
    },
    cell: ({ row }) => row.original.amountOfModelRuns,
  },
  {
    accessorKey: 'cost',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.cost')}
          enableSorting
        />
      );
    },
    cell: ({ row }) => formatter.metrics.cost(row.original.cost),
  },
  {
    accessorKey: 'time',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.latency')}
          enableSorting
        />
      );
    },
    cell: ({ row }) => formatter.metrics.time(row.original.time),
  },
  {
    accessorKey: 'cer',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.cer')}
          enableSorting
        />
      );
    },
    cell: ({ row }) => formatter.metrics.cer(row.original.cer),
  },
  {
    accessorKey: 'wer',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.wer')}
          enableSorting
        />
      );
    },
    cell: ({ row }) => formatter.metrics.wer(row.original.wer),
  },
  {
    accessorKey: 'structuralDistance',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.structuralDistance')}
          enableSorting
        />
      );
    },
    cell: ({ row }) =>
      formatter.metrics.structuralDistance(row.original.structuralDistance),
  },
];
